export const schemaEvents = {
  ON_STATE_CHANGED: 'stateChanged',
  ON_STYLE_CHANGED: 'styleChanged',
  ON_DELETE: 'schemaNodeDeleted',
  ON_UNDO: 'undo',
  ON_REDO: 'redo'
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/schema-events.js